export const employeur = {
  profil : 'Employeur',
  firstname : "Jean-Jacques",
  name : "Dupont",
  cabinets: [
    {
      name: 'Pearson Specter',
      isActive: true
    },
    {
      name: 'Pearson Specter Litt'
    },
    {
      name: 'Specter Litt'
    }
  ],
  pack: [
    {
      type: 'Santé',
      slug: 'sante',
      active: true,
      link: '/employeur/pack/sante',
      current: {
        state: 'en cours',
        name: 'Vikater',
        option: 'A3',
        support: '75%',
        subscription: {
          start : '15/10/2020'
        },
        details: [
          {
            title : 'UNIFORME',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 76,
                total: 921
              },
              {
                title: 'salarié',
                price: 19,
                total: 228
              }
            ]
          },
          {
            title : 'NIVEAU DE COUVERTURE',
            type: 'cover',
            value : 4
          }
        ],
        buttons : [{
          link: '/',
          text : "J'optimise mes garanties"
        }]
      },
      next: {
        state: 'à venir',
        name: 'Vikater',
        option: 'A5',
        support: '100%',
        subscription: {
          start : '15/10/2020'
        },
        details: [
          {
            title : 'UNIFORME',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 76,
                total: 921
              },
              {
                title: 'salarié',
                price: 19,
                total: 228
              }
            ]
          },
          {
            title : 'NIVEAU DE COUVERTURE',
            type: 'cover',
            value : 4
          }
        ],
        buttons : [{
          link: '/',
          text : "J'optimise mes garanties"
        }]
      },
      affiliated_salaries: [
        {
          affiliation_status: 'affiliated',
          affiliation_date: '16 mars 2020',
          affiliation_salary: 'Vincent Goncalves',
          status: 'cadre',
          dsn_updated: 'oui'
        },
        {
          affiliation_status: 'progressing',
          affiliation_date: '14 mars 2020',
          affiliation_salary: 'Vincent Goncalves',
          status: 'cadre',
          dsn_updated: 'non'
        },
        {
          affiliation_status: 'affiliated',
          affiliation_date: '12 mars 2020',
          affiliation_salary: 'Vincent Goncalves',
          status: 'cadre',
          dsn_updated: 'non'
        }
      ]
    },
    {
      type: 'Prévoyance',
      slug: 'prevoyance',
      link: '/employeur/pack/sante',
    },
    {
      type: 'Dépendance',
      slug: 'dependance',
      active: true,
      link: '/employeur/pack/sante',
      current: {
        subscription: {
          start : '15/10/2020'
        }
      }
    },
    {
      type: 'Retraite',
      slug: 'retraite',
      active: true,
      link: '/employeur/pack/sante',
      current: {
        subscription: {
          start : '15/10/2020'
        }
      }
    },
    {
      type: 'IFC',
      slug: 'ifc',
      link: '/employeur/pack/sante'
    }
  ],
  salaries : [
    {
      firstname: 'Rachel',
      name: 'Campbell',
      email: 'rachel@society.fr',
      working: true,
      status: 'cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    },
    {
      firstname: 'Louis',
      name: 'Diaz',
      email: 'louis@society.fr',
      working: true,
      status: 'non-cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    },
    {
      firstname: 'Barbara',
      name: 'Patterson',
      email: 'barbara@society.fr',
      working: false,
      status: 'cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    },
    {
      firstname: 'Kathleen',
      name: 'Nelson',
      email: 'kathleen@society.fr',
      working: true,
      status: 'cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    },
    {
      firstname: 'Billy',
      name: 'Thompson',
      email: 'billy@society.fr',
      working: false,
      status: 'cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    },
    {
      firstname: 'Bobby',
      name: 'Ross',
      email: 'bobby@society.fr',
      working: true,
      status: 'cadre',
      affiliation_status: 'affiliated',
      affiliation_exemption: 'Non',
      affiliation_date_start: '16/03/2020',
      affiliation_date_end: '-',
      covered_partners: 1,
      covered_children: 2,
    }
  ],
  demandes: [
    {
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'uncomplete'
    },
    {
      demande_date: '12/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'progressing'
    },
    {
      demande_date: '10/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'uncomplete'
    },
    {
      demande_date: '09/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'clotured'
    },
    {
      demande_date: '07/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'clotured'
    }
  ],
  payments: [
    {
      payment_motif: 'Remboursement IFC',
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement réalisé',
      payment_price: '500',
      payment_date: '16/02/2022',
    },
    {
      payment_motif: 'Remboursement Arret de travail',
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement gelé',
      payment_price: '200',
      payment_date: '16/02/2022',
    },
    {
      payment_motif: "déclaration d'un décès",
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement réalisé',
      payment_price: '300',
      payment_date: '16/02/2022',
    }
  ],
  contributions: [
    {
      contribution_periode: '1er trimestre 2019',
      contribution_declared: '800',
      contribution_paid: '800',
      contribution_solde: '0',
      contribution_payment_type: 'Virement bancaire',
    },
    {
      contribution_periode: '2ème trimestre 2019',
      contribution_declared: '800',
      contribution_paid: '800',
      contribution_solde: '0',
      contribution_payment_type: 'Virement bancaire',
    },
    {
      contribution_periode: '3ème trimestre 2019',
      contribution_declared: '800',
      contribution_paid: '500',
      contribution_solde: '300',
      contribution_payment_type: 'Chèque bancaire',
    }
  ],
  dns: {
    last_update: "16/08/2020"
  },
  documents: [
    {
      title: 'Santé',
      value: 'sante',
      isSolution: true,
      files : [
        {
          title : 'Contrat en cours',
          list : [
            { title: 'Notice', link: '#'},
            { title: 'Modèle DUE', link: '#'},
            { title: 'Règlement général', link: '#'},
            { title: 'Conditions générales', link: '#'}
          ],
          download: '#'
        },
        {
          title : 'Contrat à venir',
          list : [
            { title: 'Livret employeur', link: '#'},
            { title: 'Tableaux de garantie', link: '#'},
            { title: 'Règlement général', link: '#'}
          ],
          download: '#'
        }
      ]
    },
    {
      title: 'Prévoyance',
      value: 'prevoyance',
      isSolution: true,
      files : [
        {
          list : [
            { title: 'Notice', link: '#'},
            { title: 'Modèle DUE', link: '#'},
            { title: 'Règlement général', link: '#'},
            { title: 'Conditions générales', link: '#'}
          ]
        }
      ]
    },
    {
      title: 'Dépendance',
      value: 'dependance',
      isSolution: true,
      files : [
        {
          list : [
            { title: 'Notice', link: '#'}
          ]
        }
      ]
    },
    {
      title: 'IFC',
      value: 'ifc',
      isSolution: true,
      files : [
        {
          list : [
            { title: 'Notice', link: '#'},
            { title: 'Modèle DUE', link: '#'},
            { title: 'Règlement général', link: '#'}
          ]
        }
      ]
    },
    {
      title: 'Fiches de paramétrage DSN',
      value: 'dsn',
      files : [
        {
          list : [
            { title: 'Notice', link: '#'},
            { title: 'Modèle DUE', link: '#'},
            { title: 'Règlement général', link: '#'}
          ]
        }
      ]
    },
    {
      title: 'Comptes rendus métier',
      value: 'metier',
      files : [
        {
          list : [
            { title: 'Notice', link: '#'}
          ]
        }
      ]
    },
    {
      title: 'Base documentaire',
      value: 'base',
      files : [
        {
          list : [
            { title: 'Notice', link: '#'},
            { title: 'Modèle DUE', link: '#'},
            { title: 'Règlement général', link: '#'}
          ]
        }
      ]
    }
  ]
}
